import * as ng from 'angular';

interface Publishable {
    created_at: string;
    published_at: string | null;
}

export default (module: ng.IModule) => {
    module.component('tyPostDateLabel', {
        bindings: {
            publishable: '<',
        },
        template: require('./post-date-label.component.html').default,
        controller: PostDateLabelCtrl,
    });
};

class PostDateLabelCtrl implements ng.IComponentController {
    private publishable?: Publishable;

    constructor() {}

    get postIsFromTheFuture() {
        if (this.publishable === undefined) return false;
        if (this.publishable.published_at === null) return false;

        return new Date(this.publishable.published_at) > new Date();
    }
}
